module.exports = __webpack_public_path__ + "media/images/marisol_malhas_en-c6e23a57842c279e0635127a33a4eeb8.jpg";